import { BadgeProps } from '@razorpay/blade/components';
import { BankAccountResponse } from 'api/employeeBankAccount';

import { BankAccountVerificationStatus } from 'api/employeeBankAccount';

export const unverifiedStatuses: Partial<BankAccountVerificationStatus>[] = [
  'created',
  'failed',
  'invalid',
];

export const getStatusBadgeProps = (
  isRxCurrentAccountMerchant: boolean,
  bankAccount?: BankAccountResponse,
): {
  color: BadgeProps['color'];
  label: string;
} | null => {
  if (!bankAccount) {
    return null;
  }

  if (
    bankAccount.is_active &&
    unverifiedStatuses.includes(bankAccount.verification_status) &&
    isRxCurrentAccountMerchant
  ) {
    return {
      color: 'notice',
      label: 'Unverified',
    };
  }

  if (bankAccount.is_active) {
    return {
      color: 'positive',
      label: 'Active',
    };
  }

  if (bankAccount.approval_status === 'rejected') {
    return {
      color: 'negative',
      label: 'Rejected',
    };
  }

  if (bankAccount.approval_status === 'pending') {
    return {
      color: 'information',
      label: 'Approval Pending',
    };
  }

  return {
    color: 'neutral',
    label: 'Inactive',
  };
};
